import _ from 'lodash';

import ListController from "react-mui-lib/list/controller";
import ClientsideGridController from "react-mui-lib/grid-clientside/controller";
import ClientsideGridReducer from "react-mui-lib/grid-clientside/reducer";
import registry from "react-mui-lib/registry";

import "./admin-help-controller";
import { has_superaccess } from "../utils";


class BeaconListController extends ClientsideGridController {
    getAsOptions() {
        return this.state.rows.map(beacon => ({
            val: beacon.id,
            label: `${beacon.description} (${beacon.ibeacon_major}, ${beacon.ibeacon_minor})`
        }));
    }
}

registry.register('beacon_list_controller', new BeaconListController({
    entity_name: 'beacon',
    state_prefix: 'beacon_list',
    order_col: 'description'
}));


class RegionListController extends ListController {
    getAsOptions() {
        return this.state.rows.map(region => ({
            val: region.id.toString(),
            label: region.name
        }));
    }
}

registry.register('region_list_controller', new RegionListController({
    entity_name: 'region',
    state_prefix: 'region_list',
    order_col: 'name'
}));


class LocalityListController extends ListController {
    getAsOptionsForRegion(region_id) {
        const region_str = String(region_id);
        const rows = this.state.rows.filter(locality =>
            String(locality.region_id) === region_str);

        return rows.map(locality => ({
            val: locality.id,
            label: locality.name
        }));
    }
}

registry.register('locality_list_controller', new LocalityListController({
    entity_name: 'locality',
    state_prefix: 'locality_list',
    order_col: 'name'
}));


class FranchiseListReducer extends ClientsideGridReducer {
    // Same as parent _process, but null/empty values always sort last.
    _process(state) {
        const dir = state.order_dir === 'asc' ? 1 : -1;
        const col = state.order_col;
        const rows = state.rows;

        rows.sort((a, b) => {
            const av = _.get(a, col);
            const bv = _.get(b, col);
            const ae = av === null || av === undefined || av === '';
            const be = bv === null || bv === undefined || bv === '';
            if (ae && be) return 0;
            if (ae) return 1;
            if (be) return -1;
            return dir * ('' + av).localeCompare('' + bv);
        });

        rows.forEach((r, i) => r._index = i);

        const page = rows.slice(
            (state.current_page - 1) * state.rows_per_page,
            state.current_page * state.rows_per_page
        );
        return _.assign({}, state, {rows, page});
    }
}

class FranchiseListController extends ClientsideGridController {
    franchiseLabel(franchise) {
        const name = franchise.organizer_name || franchise.name || '—';
        const phone = franchise.organizer_phone || franchise.name || '—';
        return `${name} (${phone})`;
    }

    getAsOptions() {
        const res = this.state.rows.map(franchise => ({
            val: franchise.id,
            label: this.franchiseLabel(franchise)
        }));

        res.sort((a, b) => a.label.localeCompare(b.label));

        return res;
    }

    _searchText(franchise) {
        const locality = franchise.locality || {};
        const region = locality.region || {};
        return [
            franchise.name,
            franchise.organizer_name,
            franchise.organizer_phone,
            locality.name,
            region.name
        ].filter(Boolean).join(' ').toLowerCase();
    }

    _filteredRows() {
        const rows = this.state.rows;
        const search = (this.state.search || '').toLowerCase();
        if (!search) {
            return rows;
        }
        return rows.filter(franchise => this._searchText(franchise).includes(search));
    }

    getTotalRows() {
        return this._filteredRows().length;
    }

    getRowsForDisplay() {
        const rows = this._filteredRows();
        const state = this.state;
        const start = (state.current_page - 1) * state.rows_per_page;
        return rows.slice(start, start + state.rows_per_page);
    }

    setSearch(value) {
        super.setSearch(value);
        this.loadPage(1);
    }

    setOrderColumn(column) {
        if (column === 'last_admin_visit' && column !== this.state.order_col) {
            this.setOrder(column, 'desc');
            return;
        }
        super.setOrderColumn(column);
    }
}

registry.register('franchise_list_controller', new FranchiseListController({
    entity_name: 'franchise',
    state_prefix: 'franchise_list',
    Reducer: FranchiseListReducer,
    default_order_col: 'last_admin_visit',
    default_order_dir: 'desc'
}));


class RoleListController extends ListController {
    getAsOptions() {
        return this.state.rows.map(role => ({
            val: role.id,
            label: `${role.name} (${role.description})`
        }));
    }
}

registry.register('role_list_controller', new RoleListController({
    entity_name: 'role',
    state_prefix: 'role_list',
    order_col: 'name'
}));


export function load_options_before_render() {
    let promises = [
        registry.get('beacon_list_controller').load()
    ];

    if (has_superaccess()) {
        promises = promises.concat([
            registry.get('region_list_controller').load(),
            registry.get('locality_list_controller').load(),
            registry.get('franchise_list_controller').load(),
            registry.get('role_list_controller').load()
        ]);
    }

    return Promise.all(promises);
}


export function load_options() {
    registry.get('admin_help_controller').load();
}
